<template>
  <div class="categories">
    <v-card-text >
      <div class="chat-list" v-for="item in items" :key="item.Id">
        <div class="chat-prev" v-on:click="goToDetail(item.Id)">
          <div class="row">
            <div class="col-2" style="padding-right: 0px;align-self: center;">
              <img style="width: 44px;height: 44px" class="rounded-circle" :src="item.ImageUrl"/>
            </div>
            <div class="col-9" style="align-self: center;">
            <span class="name">
              {{item.ProductTypeTitle}}
            </span>
            </div>
            <div class="col-1" style="align-self: center">
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </div>
          </div>

        </div>

      </div>

    </v-card-text>
  </div>

</template>
<script>
  export default {
    props:[
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        items:[],

      }
    },
watch: {

    },
mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      console.log('response', passing_data.ServiceOutBranchOnFinalize)

      this.get_categories()
    },
    methods: {
      goToDetail (item_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.cat_id = item_id
        passing_data.request_name = this.$t('repair')
        localStorage.setItem('request_data', JSON.stringify(passing_data))

        this.$router.push({ name: 'groups', params: {} })
      },
      get_categories () {
        var self = this
          const send_data = {
            Phone: this.mobile,
          }
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/GetRequestTypeList', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response', response)
                // self.user_registered = true;
                // self.fullName = response.data.msg;
                // self.level = 2;
                self.items = response.data.Types
                // if (self.items.length == 1) {
                //   self.goToDetail(self.items[0].Id)
                // }
              } else {
                self.not_register = true
              }
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })
      }
    }
  }
</script>
